import { useEffect, useState } from 'react';

/**
 * Live media-query match, for layouts CSS alone can't switch (rendering a different component
 * tree per breakpoint, e.g. My bookings' table→cards swap). Prefer plain CSS media queries when
 * only styling changes.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches); // re-sync if the query prop changed between renders
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
